// Wrappers around the callable Cloud Functions.

import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export async function generateQuestions(examId, count) {
  const fn = httpsCallable(functions, 'generateQuestions');
  const res = await fn({ examId, count });
  return res.data.items;
}

export async function createCheckoutSession(examId) {
  const fn = httpsCallable(functions, 'createCheckoutSession');
  const res = await fn({ examId });
  return res.data.url;
}

export async function createPortalSession() {
  const fn = httpsCallable(functions, 'createPortalSession');
  const res = await fn({});
  return res.data.url;
}

export async function setAdminRole(targetUid, admin) {
  const fn = httpsCallable(functions, 'setAdminRole');
  await fn({ targetUid, admin });
}

// Exam-profile writes go through this server-validated callable — direct
// client writes to examProfiles are denied by the security rules. The callable
// re-checks the admin claim and validates the document shape before persisting.
export async function upsertExamProfile(profile) {
  const fn = httpsCallable(functions, 'upsertExamProfile');
  const res = await fn(profile);
  return res.data;
}
